import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { AnalyticsService } from '@sm360/widget-commons-general';

class QuoteElement extends React.Component {
    constructor(props) {
        super(props);

        this.manageAnalytics = this.manageAnalytics.bind(this);
    }

    manageAnalytics() {
        AnalyticsService.pushDataLayer('login-widget|pending-transaction', 'click', 'Complete your Transaction');
    }

    render() {
        const quote = this.props.quote;
        const vehicle = quote.vehicle;
        const quoteParam = `quoteId=${quote.id}`;
        const vehicleParam = `vehicleId=${vehicle.vehicleId}`;
        const path = `/en/checkout?${quoteParam}&${vehicleParam}`;

        const linkBlock = (
            <a href={path} className="btn-purchase" onClick={this.manageAnalytics()}>
                {LocaleService.t('LOGIN.LOGIN_COMPLETE_PURCHASE')}
            </a>
        );

        return (
            <li>
                <p className="quote-vehicle">{`${vehicle.year} ${vehicle.make} ${vehicle.model}`}</p>
                {linkBlock}
            </li>
        );
    }
}

QuoteElement.propTypes = {
    quote: React.PropTypes.shape({
        vehicleId: React.PropTypes.number,
        make: React.PropTypes.string,
        model: React.PropTypes.string,
        year: React.PropTypes.number,
    }).isRequired,
};

QuoteElement.displayName = 'QuoteElement';

export default QuoteElement;



// WEBPACK FOOTER //
// ./src/components/Quotes/QuoteElement.jsx